// import clone from 'clone'
// import { initialState } from '../index'
import { CREDITNOTE_INIT_LOADING, CREDITNOTE_INIT_SUCCESS, CREDITNOTE_INIT_FAIL, CREDITNOTE_LOAD_DATA } from '@/store/types'

export const init = {
  [CREDITNOTE_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [CREDITNOTE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [CREDITNOTE_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [CREDITNOTE_LOAD_DATA] (state, data) {
    state.creditNoteData.branch = data.branch
    state.creditNoteData.accountNo = data.accountNo
    state.creditNoteData.type = data.type
    state.creditNoteData.documentNo = data.documentNo
    state.creditNoteData.fund = data.fund
    state.creditNoteData.suffix = data.suffix
    state.creditNoteData.tranMode = data.tranMode
    state.creditNoteData.currency = data.currency
    state.creditNoteData.amount = data.amount
    state.creditNoteData.gstAmountAE = data.gstAE
    state.creditNoteData.gstAmount = data.gst
    state.creditNoteData.netAmount = data.netAmt
    state.creditNoteData.netLocAmountAE = data.netLocAmtAE
    state.creditNoteData.netLocAmount = data.netLocAmt
    state.creditNoteData.tranDate = data.tranDate
    state.creditNoteData.actionName = data.actionName
    state.creditNoteData.printDoc = data.printDoc
  }
}
